import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import WorkspaceCreatePage from '@/pages/workspace/create'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({
  draftWorkspaceId: z.string().uuid().optional(),
  step: z.literal('plugins').optional(),
})

export type WorkspaceCreateSearch = z.infer<typeof searchSchema>

export const Route = createFileRoute('/$lang/workspace/create')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    requireAuthenticated(context, params)
  },
  component: WorkspaceCreatePage,
  staticData: { layout: 'main' },
})
